
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/for-finance-payments",
      function () {
        return require("private-next-pages/admin/for-finance-payments/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/for-finance-payments"])
      });
    }
  